// @ts-nocheck
/* eslint-disable */
export const appCancel32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 6L6.00002 26" stroke="currentColor" stroke-width="2.5"/><path d="M26 26L6.00002 6.00002" stroke="currentColor" stroke-width="2.5"/></svg>`,
    name: 'cancel-32' as const
};